export default __webpack_public_path__ + "static/media/transparency_and_reporting.3d48a104.svg";